import React from 'react';
import HBCheckbox from '../../HBCheckbox/HBCheckbox';
import type { IFilterOption, TFilterField } from '../HBFilters.types';
import { useFilters } from '../hooks/useFilters';
import { ListItem } from './PopoverBase';
import FilterTag from './FilterTag';

/**
 * Props for the HBMultiSelectFilter component.
 * Represents a multi-select filter field in the filter bar.
 */
interface IHBMultiSelectFilterProps {
    field: TFilterField;
    value: IFilterOption[];
}

interface IFilterOptionProps {
    option: IFilterOption;
    isSelected: boolean;
    onToggle: (option: IFilterOption) => void;
}

const FilterOption = ({ option, isSelected, onToggle }: IFilterOptionProps) => (
    <ListItem
        testId="multi-select-filter-list-item"
        $alignment={'left'}
        key={option.value}
        onClick={() => onToggle(option)}
        size="md"
        rounded
    >
        <HBCheckbox
            size="sm"
            checked={isSelected}
            onChange={() => {}}
            testIdName={`multi-select-checkbox-${option.value}`}
        />
        <FilterTag
            tag={{
                _id: option.value,
                tag_name: option.label,
                color: option.color
            }}
        />
    </ListItem>
);

/**
 * HBMultiSelectFilter renders a vertical list for multi-select filter fields using HBListItem and HBCheckbox.
 * Allows selecting and deselecting multiple options.
 */
const HBMultiSelectFilter = ({ field, value }: IHBMultiSelectFilterProps) => {
    const { toggleMultiSelect } = useFilters();
    const selectedSet = new Set(value.map(v => v.value));

    return (
        <>
            {field.options.map(option => (
                <FilterOption
                    key={option.value}
                    option={option}
                    isSelected={selectedSet.has(option.value)}
                    onToggle={toggledOption =>
                        toggleMultiSelect(field.id, toggledOption)
                    }
                />
            ))}
        </>
    );
};

export default HBMultiSelectFilter;
